import HelpActionTms from "./HelpActionTms";
import Legenda from "./Legenda";
import { useState } from "react";
import PainelTms from "./PainelTms";
import { limpa, limpaLegenda, valid, download, onCritChange2, onSpecChange2, onSpecBlur2, cparte2, sh2, processaResultados } from "./Aux.js";


const Tms = (props) => {

    props.setComp('tms');
    document.title = "bqmaps";
    document.querySelector('meta[name="description"]').setAttribute('content','Metro do Porto. Consultar número de passagens de veículos por troço e sentido. Query number of vehicles passed by stretch and direction.');
    
    const [csv, setCsv] = useState('');
    var specs = { ...props.specs };
    var tratados = new Array(83).fill([0, 0, 0]);

    function tmsQuery(e) {
        e.preventDefault();
        limpaLegenda();
        let s = { ...props.specs };
        let tableName = "resultados";
        let veic = props.specs.veiculos;
        veic = veic.split(" ");
        veic = limpa(veic, 1, 140, props.ling, '');
        s.veiculos = veic.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let lin = props.specs.linhas;
        lin = limpaLinhas(lin);
        s.linhas = lin.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let tipo = props.specs.tipo;
        if (tipo === '') {
            tipo = '0 1 2 3 4 5 6';
        }
        tipo = tipo.split(" ");
        tipo = limpa(tipo, 0, 6, props.ling, '0');
        if (tipo.length < 1) {
            tipo = ['1', '2', '3', '4', '5', '6', '0'];
            alert('Input errado para dias da semana foi substituído. / Wrong input for week days was replaced.')
        };
        let ltipo = [];
        for (let i = 0; i < tipo.length; i++) {
            ltipo.push(props.varGlob.dsem[parseInt(tipo[i]) - 1]);
        }
        s.tipo = tipo.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let dmes = props.specs.dmes;
        dmes = dmes.split(" ");
        dmes = limpa(dmes, 1, 31, props.ling, '');
        s.dmes = dmes.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let nv = parseInt(props.specs.nv);
        let shortv = props.varGlob.shortvartms[nv];
        let anos = props.specs.anos;
        if (anos === '') {
            anos = '2016 2017 2018 2019 2020 2021';
        }
        anos = anos.split(" ");
        anos = limpa(anos, 2016, 2021, props.ling, 2021);
        if (anos.length < 1) {
            anos = ['2016', '2017', '2018', '2019', '2020', '2021'];
            alert('Input errado para anos foi substituído. / Wrong input for years was replaced.')
        };
        s.anos = anos.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let meses = props.specs.meses;
        if (meses === '') {
            meses = '1 2 3 4 5 6 7 8 9 10 11 12';
        }
        meses = meses.split(" ");
        meses = limpa(meses, 1, 12, props.ling, 2);
        if (meses.length < 1) {
            meses = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
            alert('Input errado para meses foi substituído. / Wrong input for months was replaced.')
        };
        let lmeses = [];
        for (let i = 0; i < meses.length; i++) {
            lmeses.push(props.varGlob.m[parseInt(meses[i]) - 1]);
        }
        s.meses = meses.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let horas = props.specs.horas;
        if (horas === '') {
            horas = '1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24';
        }
        horas = horas.split(" ");
        horas = limpa(horas, 1, 24, props.ling, 8);
        if (horas.length < 1) {
            horas = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
            alert('Input errado para horas foi substituído. / Wrong input for hours was replaced.')
        };
        s.horas = horas.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        specs = s;
        let mensagem = "Coloridos os troços em função de " + shortv + "<br>";
        mensagem += "<br>Do(s) ano(s):      " + anos;
        mensagem += "<br>No(s) mes(es) de:     " + lmeses;
        mensagem += "<br>Na(s) hora(s):     " + horas;
        let filtro = anos + ";" + lmeses + ";" + horas + ";" + ltipo + ";";
        if (ltipo.length > 0) {
            filtro += ltipo + ";";
            mensagem += "<br>Nos dias tipo:     " + ltipo;
        }
        filtro = anos + ";" + lmeses + ";" + horas + ";" + ltipo + ";";
        if (props.specs.fer - props.specs.nfer !== 0) {
            if (props.specs.fer === 0) {
                filtro += " Não feriado ;";
                mensagem += " Não feriado ";
            } else {
                filtro += " Feriado ;";
                mensagem += " Feriado ";
            }
        }
        if (dmes.length > 0) {
            filtro += dmes + ";";
            mensagem += "<br>Nos dias do mês:    " + dmes;
        }
        if (veic[0]) {
            filtro += veic + ";";
            mensagem += "<br>Dos veiculos:      " + veic;
        } else {
            if (props.specs.et !== props.specs.tt) {
                mensagem += "<br>Dos veiculos:      ";
                if (props.specs.et) {
                    filtro += " ET ;";
                    mensagem += " ET ";
                } else {
                    filtro += " TT ;";
                    mensagem += " TT ";
                }
            }
        }
        if (lin.length > 0) {
            filtro += lin + ";";
            mensagem += "<br>Nas linhas:    " + lin;
        }
        const params = {
            "serv": "tms",
            "anosm": anos,
            "mesesm": meses,
            "horasm": horas,
            "tipom": tipo,
            "dmesm": dmes,
            "veic": veic,
            "lin": lin,
            "ferm": props.specs.fer,
            "nferm": props.specs.nfer,
            "et": props.specs.ET,
            "tt": props.specs.TT,
            "tableNamem": tableName
        };
        tmsFetchAsync(
            "/bqmapsnode/?params=" + JSON.stringify(params), filtro
        );
    }

    function limpaLinhas(lista) {
        let nova = [];
        for (let i = 0; i < lista.length; i++) {
            if ("ABCDEFGZ".includes(lista[i])) {
                nova.push(lista[i]);
            } else {
                alert(lista[i] + " não existe.");
            }
        };
        return nova;
    }

    async function tmsFetchAsync(url, filtro) {
        let response = await fetch(url, {
            mode: 'no-cors',
            credentials: 'same-origin',
        });
        if (response.ok) {
            let resultados = await response.json();
            if (resultados != null && resultados.length > 0) {
                console.log(resultados);
                let s = { ...specs };
                s.res = resultados;
                props.setSpecs(s);
                tmsSaveCsv(resultados, filtro);
                return resultados;
            } else {
                tmsAlertaDados();
                return resultados;
            }
        } else {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
    }

    function tmsAlertaDados() {
        if (props.ling === 'pt') {
            alert('Não há dados para o período especificado!  Só para Jan 2016 a Fev 2021 inc para todos os dias e para Nov 2016 a Fev 2021 para dias úteis.');
        } else {
            alert('No data for the specified period! Only for Jan 2016 to Feb 2021, inc. (for all days) and for Nov 2016 to Feb 2021, inc. (for week days)')
        }
    }

    async function tmsSaveCsv(resultados, filtro) {
        setCsv('');
        let nv = parseInt(props.specs.nv);
        let tratados = processaResultados(resultados, nv, props.varGlob.stationAtms, props.varGlob.stationBtms);
        let csvCont = "Anos;Meses;Horas;Dias;Veículos;Linhas \n";
        csvCont = csvCont + filtro + "\n \n";
        csvCont = csvCont + "De;Para;Passagens \n";
        for (let i = 0; i < tratados.length; i++) {
            if (tratados[i][2] === 0) { break }
            if (nv === 0) {
                csvCont = csvCont + props.varGlob.stationA[tratados[i][0]] + ";";
                csvCont = csvCont + props.varGlob.stationB[tratados[i][0]] + ";";
            } else {
                csvCont = csvCont + props.varGlob.stationB[tratados[i][0]] + ";";
                csvCont = csvCont + props.varGlob.stationA[tratados[i][0]] + ";";
            }
            csvCont = csvCont + parseInt(tratados[i][2]) + "\n";
        }
        tratados = tratados.fill([0, 0, 0]);
        let response = await fetch("/bqmapsnode/?fileToWrite=" + encodeURIComponent(csvCont), {
            mode: 'no-cors',
            credentials: 'same-origin',
        })
        let fileName = await response.json();
        if (!response.ok) {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
        setCsv(fileName);
    }


    /* useEffect(() => {
        document.getElementById("menu").style.marginLeft = '160px';
    }, []); */


    return (
        <div className="tms">
            <div id="toast"></div>
            <div id="stats">
                <div id="menu">
                    <HelpActionTms
                        ling={props.ling}
                        titPt={"Colorir troços em função de:"}
                        titUk={"To color stretches according to:"}
                        helpPt={"https://docs.google.com/presentation/d/1WeHDSaywD_WwJEcljdywsBhPZmsHSBp-87GsS522kQA/edit?usp=sharing"}
                        helpUk={"https://docs.google.com/presentation/d/1Ei54znAJMQYMDYha8rpGkqC3Us40c0l6dr9Zn7SyKLw/edit?usp=sharing"}
                        varGlob={props.varGlob}
                        onSpecChange2={onSpecChange2}
                        specs={specs}
                        setSpecs={props.setSpecs}
                        query={tmsQuery}
                        csv={csv}
                        download={download} />
                    <PainelTms
                        ling={props.ling}
                        specs={props.specs}
                        setSpecs={props.setSpecs}
                        comp={props.comp}
                        setComp={props.setComp}
                        valid={valid}
                        onCritChange2={onCritChange2}
                        sh2={sh2}
                        onSpecChange2={onSpecChange2}
                        onSpecBlur2={onSpecBlur2}
                        cparte2={cparte2}
                        varGlob={props.varGlob} />
                    <Legenda />
                </div>
            </div>
        </div>
    );
}

export default Tms;